<template>
  <v-container class="will-location-container">
    <div v-if="!loading">
      <v-row no-gutters>
        <v-col cols="12" sm="1">
          <router-link :to="{ name: 'OverviewPage' }" class="back-arrow"
            ><v-icon large color="mid-grey" class="mt-1">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11">
          <h1 class="mb-2">Will location and contact</h1>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-sm-6">
        <v-col cols="12" md="4" offset-md="1" class="form-blurb"></v-col>
        <v-col cols="12" md="7">
          <div class="left-section-container">
            <SetWillLocation
              :testator="testator"
              :people-relations="peopleRelations"
            />
            <div class="button-container">
              <GradientButton
                :title="'Save And Continue'"
                :callout="'right'"
                :small="true"
                @gradientButtonClicked="navigateBack"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-else class="text-center mt-12">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />

    <TestatorAssistanceGuide />
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import SetWillLocation from '../will_verification/SetWillLocation.vue';
  import { getRelations } from '../../constants/js/people';
  import TestatorAssistanceGuide from '../common/dialogs/TestatorAssistanceGuide.vue';

  export default {
    name: 'WillLocation',
    components: {
      ErrorSnackbar,
      SetWillLocation,
      TestatorAssistanceGuide,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        testator: {},
        loading: true,
        peopleRelations: {},
        errorMessage: null,
      };
    },
    methods: {
      navigateBack() {
        this.$router.back();
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data) {
            this.peopleRelations = getRelations(response.data.testator.people);
            this.loading = false;
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .will-location-container {
    padding-top: 40px;
    padding-bottom: 60px;

    .left-section-container {
      padding-left: 121px;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .will-location-container {
      .left-section-container {
        padding-left: 0;
      }
    }
  }
</style>
